import gql from "graphql-tag";

export const IS_USER_A_CREATOR = gql`
    query isUserACreator($username: String!) {
        creatorData: creatorProfileDetailByUsername(username: $username) {
            id
        }
    }
`;
